/** Keep name spelling, punctuation, accents, and spacing; change case only. */
export function uppercaseName(value: string): string {
	return value.toUpperCase();
}
